<template>
  <div>
    <h1>Liste des modules - Accès Admin</h1>
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>Module</th>
          <th>Description</th>
          <th>Groupe</th>
          <th>Position</th>
          <th>Admin ?</th>
          <th>Public ?</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="module in modules" :key="module.Id">
          <td>{{ module.Title }}</td>
          <td>{{ module.Desc }}</td>
          <td>
            <select :value="module.IdGroupe" class="form-control" @change="updateGroup($event, module.Id)">
              <option v-for="group of moduleGroups" :key="group.Id" :value="group.Id">
                {{group.Name}}
              </option>
            </select>
          </td>
          <td>
            <input  class="form-control" type="number" name="admin" :value="module.Position" @change="updatePosition($event, module.Id)" />
          </td>
          <td>
            <input  type="checkbox" name="admin" :checked="module.AdminOnly" @click="updateAdminOnly(module.Id, !module.AdminOnly, $event)" />
          </td>
          <td>
            <input  type="checkbox" name="admin" :checked="module.IsPublic" @click="updateIsPublic(module.Id, !module.IsPublic, $event)" />
          </td>
        </tr>
      </tbody>
    </table>
    <!--<vue-good-table :columns="columns"
                    :rows="usersRights"
                    :sort-options="{enabled: true}"
                    :pagination-options="{
                                        enabled: true,
                                        rowsPerPageLabel: 'Lignes par page',
                                        ofLabel: 'sur',
                                        nextLabel: 'Suivant',
                                        prevLabel: 'Précédent',
                                        allLabel: 'Toutes'
                                    }">
      <template slot="table-row" slot-scope="props">
        <span v-if="/^module[0-9]+$/.test(props.column.field)">
          <input type="checkbox" @click="toggleRight($event, props)"
                 :checked="props.row[props.column.field]"/>
        </span>-->
        <!--<span v-else-if="props.column.field == 'after'">
          after
        </span>-->
        <!--<span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>-->
  </div>
</template>

<script>
  import { uniq } from "@/utils"
  import { getAllUsers } from "@/utils/cdm";
  import {
    getModules,
    getModuleGroups,
    getAllUserModuleRights,
    toggleUserModuleRight,
    updateGroup,
    updatePosition,
    updateAdminOnlyModuleStatus,
    updateIsPublicModuleStatus
  } from "@/utils/module"

  export default {
    name: "AdminRights",
    data() {
      return {
        users: [],
        rights: [],
        modules: [],
        moduleGroups: []
      }
    },
    mounted() {
      this.init()
    },
    computed: {
    },
    methods: {
      init() {
      // On récupère les modules à afficher dans l'interface
        getModuleGroups().then(res => {
          this.moduleGroups = res
          getModules(true).then(res => {
            this.modules = res;
          });
        })
      },
      updateGroup(e, moduleId) {
        updateGroup(moduleId, e.target.value).then(this.init)
      },
      updatePosition(e, moduleId) {
        updatePosition(moduleId, e.target.value).then(this.init)
      },
      // Modification du AdminOnly
      updateAdminOnly(id, state, e) {
        e.preventDefault();
        updateAdminOnlyModuleStatus(id, state).then(this.init)
      },
      updateIsPublic(id, state, e) {
        e.preventDefault();
        updateIsPublicModuleStatus(id, state).then(this.init)

      }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Admin/AdminRights.vue